import { getSuggestionsSet } from 'owa-mail-search-store';
export default function getSuggestionAtIndex(index) {
    var suggestionsSet = getSuggestionsSet();
    // Return null if there are no suggestions.
    if (!suggestionsSet || !suggestionsSet.IsComplete) {
        return null;
    }
    // If there is no suggestion at the given index, return null.
    var suggestion = suggestionsSet.Suggestions[index];
    if (!suggestion) {
        return null;
    }
    return suggestion;
}
//# sourceMappingURL=getSuggestionAtIndex.js.map